
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteD as ObiOwnShipRemoteDElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-d.js';
 
 
 

 
 export const ObiOwnShipRemoteD = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-d',
   elementClass: ObiOwnShipRemoteDElement,
   events: {
     
   }
  });
 
 